// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutId_container_6DAOC","header":"LayoutId_header_1TZW8","main":"LayoutId_main_1_aHK","versions":"LayoutId_versions_2CGTG"};